import { formatDate } from "@common";
import {
    AppState,
    campaignMediaPlanForm,
    campaignMediaPlanFormBindings,
    Country,
    Place,
    searchLocationByQueryAction,
    LanguagesMapping,
    GenderMapping,
    AgeMapping,
    InterestMapping,
    DeviceMapping,
    AdUnitFormat,
    campaignCreativesForm,
    campaignCreativesFormBindings,
    RestrictionMapping,
    setPriceModelAction,
    changeUpdateCheckTimetableFlagAction,
    openTimetableWarningAction,
    setAdUnitFormatAction,
    KPIMapping,
    setPrimaryKPIAction
} from "@store";
import { FETCH_STATE, FETCH_STATE_ERROR, FETCH_STATE_INITIAL, FETCH_STATE_SUCCESS, FetchingState } from "rd-redux-http";
import * as React from "react";
import DayPickerInput from "react-day-picker/DayPickerInput";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { CalendarToolForTimeOrganization } from "../icons";
import { AccordionCardComponent } from "./AccordionCard";
import { AgeComponent } from "./campaignForm/AgeComponent";
import { GenderComponent } from "./campaignForm/GenderComponent";
import { GeographicComponent } from "./campaignForm/GeographicComponent";
import { InterestTargetingComponent } from "./campaignForm/InterestTargeting";
import { LanguageComponent } from "./campaignForm/LanguageComponent";
import { PlacementTypeComponent } from "./campaignForm/PlacementTypeComponent";
import { PricingModelComponent } from "./campaignForm/PricingModelComponent";
import { RestrictionsComponent } from "./campaignForm/RestrictionsComponent";
import { FakeComponent } from "./FakeComponent";
import { AdFormatsComponent } from "./campaignForm/AdFormatsComponent";
import { Fieldset } from "./Fieldset";
import * as cn from "classnames";
import "react-day-picker/lib/style.css";

export interface CampaignMediaPlanFormComponentProps {
    formData: typeof campaignMediaPlanForm.types.selectorResult;
    formEvents: typeof campaignMediaPlanForm.types.eventBindings;
    creativesFormEvents: typeof campaignCreativesForm.types.eventBindings;
    adFormats: AdUnitFormat[];
    languagesMapping: LanguagesMapping[];
    genderMapping: GenderMapping[];
    kpiMapping: KPIMapping[];
    ageMapping: AgeMapping[];
    interestsMapping: InterestMapping[];
    deviceMapping: DeviceMapping[];
    restrictionsMapping: RestrictionMapping[];
    countryList: Country[];
    zipList: string[];
    placeList: string[];
    onClear: (f: string, checkBoxState: boolean, isRadio?: boolean, mapping?: string[]) => void;
    onInputSearch: (query: { zip?: string; place?: string }, region: string) => void;
    onSetPriceModel: (priceModel: string) => void;
    onSetPrimaryKPI: (primaryKPI: string) => void;
    onSetAdUnitFormat: (adUnitFormat: string) => void;
    onChangeUpdateCheckTimetableFlag: (status: boolean) => void;
    placeAndZipList: Place[];
    matchStrict: (key: string, value: string | number, data: Place[]) => boolean;
    onOpenTimetableWarning: () => void;
    debouncer: any;
    placeAndZipFetchState: FETCH_STATE_SUCCESS | FETCH_STATE_ERROR | FETCH_STATE_INITIAL | FETCH_STATE;
    updateCheckTimetableFlag: boolean;
}

export interface CampaignMediaPlanFormState {
    checkBoxes: { [k: string]: boolean };
}

export class CampaignMediaPlanFormComponent extends React.Component<
    CampaignMediaPlanFormComponentProps,
    CampaignMediaPlanFormState
> {
    constructor(props: CampaignMediaPlanFormComponentProps) {
        super(props);
        this.state = {
            checkBoxes: {
                gender:
                    this.props.formData.fields.gender.value && this.props.formData.fields.gender.value.length !== 0
                        ? false
                        : true,
                age:
                    this.props.formData.fields.age.value && this.props.formData.fields.age.value.length !== 0
                        ? false
                        : true,
                deviceType:
                    this.props.formData.fields.deviceType.value &&
                    this.props.formData.fields.deviceType.value.length !== 0
                        ? false
                        : true,
                interestTargeting: this.props.formData.fields.interestTargeting.value ? false : true
            }
        };
    }

    handleCheckBoxAction = (fieldName: string, isRadio?: boolean) => {
        const { onClear, genderMapping, ageMapping, deviceMapping } = this.props;
        const checkBoxState = !this.state.checkBoxes[fieldName];
        this.setState({
            ...this.state,
            ...{
                checkBoxes: {
                    ...this.state.checkBoxes,
                    ...{ [fieldName]: checkBoxState }
                }
            }
        });

        let mapping: string[];

        if (fieldName === "gender") mapping = genderMapping.map(m => m.type);
        if (fieldName === "age") mapping = ageMapping.map(m => m.type);
        if (fieldName === "deviceType") mapping = deviceMapping.map(m => m.type);

        onClear(fieldName, checkBoxState, isRadio, mapping);
    };

    handleClearAllCheckBoxes() {
        this.setState({
            ...this.state,
            checkBoxes: {
                gender: true,
                age: true,
                deviceType: true,
                interestTargeting: true
            }
        });
    }

    handleAutocompleteInput = (e: any, helper?: { name: string; value: string }) => {
        const nameMaps = {
            zipCode: "zip",
            city: "place"
        };
        const inputs = ["zipCode", "city"];
        const { name, value } = helper ? helper : e.target;
        const { formEvents, formData, onInputSearch, debouncer } = this.props;
        const query = {};

        inputs.forEach((inputName: string, index: number) => {
            const mappedInputName = nameMaps[inputName];
            const inputValue = nameMaps[name] == mappedInputName ? value : formData.fields[inputName].value;

            if (inputValue) {
                query[`search-${mappedInputName}`] = inputValue;
            }
        });

        if (Object.keys(query).length === 0) {
            query[`search-${nameMaps[name]}`] = "";
        }

        formEvents.fields[name].onChange(value);
        debouncer(() => onInputSearch(query, formData.fields.region.value));
    };

    handleChangeDate(date: "startDate" | "endDate", dateValue: string | Date | number) {
        const anotherDate = date === "startDate" ? "endDate" : "startDate";
        const anotherDateValue = this.props.formData.fields[anotherDate].value;

        if (!anotherDateValue) {
            this.props.formEvents.fields[date].onChange(formatDate(dateValue));

            return;
        }

        const isDateValueBigger: boolean = new Date(dateValue).getTime() > new Date(anotherDateValue).getTime();

        const time = new Date(dateValue);
        const newPrevDate = new Date(time).setDate(time.getDate() - 1);
        const newNextDate = new Date(time).setDate(time.getDate() + 1);

        if (date === "startDate") {
            isDateValueBigger ? this.props.formEvents.fields.endDate.onChange(formatDate(newNextDate)) : null;

            this.props.formEvents.fields.startDate.onChange(formatDate(dateValue));
        } else {
            isDateValueBigger ? null : this.props.formEvents.fields.startDate.onChange(formatDate(newPrevDate));

            this.props.formEvents.fields.endDate.onChange(formatDate(dateValue));
        }
    }

    render() {
        const {
            formData: form,
            formEvents: events,
            creativesFormEvents,
            adFormats,
            languagesMapping,
            genderMapping,
            kpiMapping,
            ageMapping,
            interestsMapping,
            deviceMapping,
            restrictionsMapping,
            countryList,
            onInputSearch,
            zipList,
            placeList,
            placeAndZipFetchState,
            onSetPriceModel,
            onSetPrimaryKPI,
            onChangeUpdateCheckTimetableFlag,
            updateCheckTimetableFlag,
            onOpenTimetableWarning,
            onSetAdUnitFormat
        } = this.props;
        const { gender, age, deviceType, interestTargeting } = this.state.checkBoxes;

        const isCpmOrVcpmModel: boolean =
            form.fields.priceModel.value === "CPM" || form.fields.priceModel.value === "vCPM";

        return (
            <form {...events.form}>
                <AccordionCardComponent cardHeader="Campaign Details" bodyClassName="campaign-details" isOpen={true}>
                    <div className="details-block">
                        <div className="details-item first-description-block tour-campaign-name-and-dates">
                            <Fieldset label="Campaign name" isMandatory={true} errorMessage={form.fields.campaignName}>
                                <input
                                    type="text"
                                    name="campaign-name"
                                    id=""
                                    maxLength={300}
                                    autoComplete="new-password"
                                    value={form.fields.campaignName.value || ""}
                                    {...events.fields.campaignName}
                                />
                            </Fieldset>
                            <div className="fieldset-row">
                                <Fieldset
                                    className="Fieldset__date fix-index-fieldset"
                                    label="Select date from"
                                    isMandatory={true}
                                    errorMessage={form.fields.startDate}
                                    icon={CalendarToolForTimeOrganization}
                                    isBadDateSvg={true}
                                >
                                    <DayPickerInput
                                        value={form.fields.startDate.value || ""}
                                        onDayChange={(day: any) => this.handleChangeDate("startDate", day)}
                                        placeholder="YYYY-MM-DD"
                                        format="YYYY-MM-DD"
                                        formatDate={formatDate}
                                        dayPickerProps={{
                                            modifiers: {
                                                disabled: [
                                                    {
                                                        before: new Date()
                                                    }
                                                ]
                                            }
                                        }}
                                        inputProps={{
                                            readOnly: true
                                        }}
                                    />
                                </Fieldset>
                                <Fieldset
                                    className="Fieldset__date"
                                    label="Select date to"
                                    isMandatory={true}
                                    errorMessage={form.fields.endDate}
                                    icon={CalendarToolForTimeOrganization}
                                    isBadDateSvg={true}
                                >
                                    <>
                                        <DayPickerInput
                                            value={form.fields.endDate.value || ""}
                                            onDayChange={(day: any) => this.handleChangeDate("endDate", day)}
                                            placeholder="YYYY-MM-DD"
                                            format="YYYY-MM-DD"
                                            formatDate={formatDate}
                                            dayPickerProps={{
                                                modifiers: {
                                                    disabled: [
                                                        {
                                                            before: new Date()
                                                        }
                                                    ]
                                                }
                                            }}
                                            inputProps={{
                                                readOnly: true
                                            }}
                                        />
                                    </>
                                </Fieldset>
                            </div>
                        </div>
                    </div>
                    <div className="details-block tour-campaign-objective">
                        <div className="details-item">
                            <div className="title-wrapper">
                                <p>Campaign goal</p>
                                <span className="title-line" />
                            </div>
                            <PricingModelComponent
                                value={form.fields.priceModel.value}
                                onChange={events.fields.priceModel.onChange}
                                field={form.fields.priceModel}
                                events={events}
                                handleClearAllCheckBoxes={() => this.handleClearAllCheckBoxes()}
                                onSetPriceModel={(priceModel: string) => onSetPriceModel(priceModel)}
                                onSetPrimaryKPI={(primaryKPI: string) => onSetPrimaryKPI(primaryKPI)}
                                kpiMapping={kpiMapping}
                                primaryKPIValue={form.fields.primaryKPI.value}
                                primaryKPIOnChange={events.fields.primaryKPI.onChange}
                                primaryKPIField={form.fields.primaryKPI}
                                secondaryKPIValue={form.fields.secondaryKPI.value}
                                secondaryKPIOnChange={events.fields.secondaryKPI.onChange}
                                secondaryKPIField={form.fields.secondaryKPI}
                            />
                        </div>
                    </div>
                </AccordionCardComponent>
                <AccordionCardComponent cardHeader="AD formats" bodyClassName="adFormats" isOpen={true}>
                    <AdFormatsComponent
                        value={form.fields.adUnitFormat.value}
                        onChange={events.fields.adUnitFormat.onChange}
                        adFormats={adFormats}
                        creativesFormEvents={creativesFormEvents}
                        onSetAdUnitFormat={(adUnitFormat: string) => onSetAdUnitFormat(adUnitFormat)}
                    />
                </AccordionCardComponent>
                <AccordionCardComponent cardHeader="Targeting" bodyClassName="targeting" isOpen={true}>
                    <div className="targeting-block custom-targetting-no-wrap tour-campaign-targeting-language-country">
                        <div className="targeting-item quarter-block">
                            <div className="title-wrapper">
                                <p>Language</p>
                                <span className="title-line" />
                            </div>
                            <LanguageComponent
                                value={form.fields.language.value}
                                onChange={events.fields.language.onChange}
                                field={form.fields.language}
                                languagesMapping={languagesMapping}
                            />
                        </div>
                        <div className="targeting-item three-quarter-block">
                            <div className="title-wrapper">
                                <p>Geographic</p>
                                <span className="title-line" />
                            </div>
                            <GeographicComponent
                                form={form}
                                events={events}
                                countryList={countryList}
                                onInputSearch={onInputSearch}
                                handleAutocompleteInput={this.handleAutocompleteInput}
                                zipList={zipList}
                                placeList={placeList}
                                placeAndZipFetchState={placeAndZipFetchState}
                            />
                        </div>
                    </div>

                    <div
                        className={cn(
                            "targeting-block custom-targetting-no-wrap",
                            isCpmOrVcpmModel ? "" : "disabled-targeting"
                        )}
                    >
                        <div className="targeting-item targeting__strict quarter-block ">
                            <div className="title-wrapper">
                                <p>Gender</p>
                                <span className="title-line" />
                            </div>
                            <div className="paragraph targeting__gender">
                                <GenderComponent
                                    value={form.fields.gender.value}
                                    onChange={{ events: { ...events.fields.gender } }}
                                    field={form.fields.gender}
                                    isDisabled={gender}
                                    onCheckBoxAction={this.handleCheckBoxAction}
                                    genderMapping={genderMapping}
                                />
                            </div>
                        </div>

                        <div
                            className={cn(
                                "targeting-item targeting__strict three-quarter-block",
                                isCpmOrVcpmModel ? "" : "disabled-targeting"
                            )}
                        >
                            <div className="title-wrapper">
                                <p>Age</p>
                                <span className="title-line" />
                            </div>
                            <div className="paragraph targeting__age">
                                <AgeComponent
                                    value={form.fields.age.value}
                                    onChange={{ events: { ...events.fields.age } }}
                                    field={form.fields.age}
                                    isDisabled={age}
                                    onCheckBoxAction={this.handleCheckBoxAction}
                                    ageMapping={ageMapping}
                                />
                            </div>
                        </div>
                    </div>

                    <div className={cn("targeting-block", isCpmOrVcpmModel ? "" : "disabled-targeting")}>
                        <div className="targeting-item full-block">
                            <div className="title-wrapper">
                                <p>Interest targeting</p>
                                <span className="title-line" />
                            </div>
                            <div className="paragraph">
                                <InterestTargetingComponent
                                    value={form.fields.interestTargeting.value}
                                    onChange={events.fields.interestTargeting.onChange}
                                    field={form.fields.interestTargeting}
                                    isDisabled={interestTargeting}
                                    onCheckBoxAction={this.handleCheckBoxAction}
                                    interestsMapping={interestsMapping}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={cn("targeting-block", isCpmOrVcpmModel ? "" : "disabled-targeting")}>
                        <div className="targeting-item device-targeting full-block">
                            <div className="title-wrapper">
                                <p>Device type</p>
                                <span className="title-line" />
                            </div>
                            <div className="paragraph">
                                <PlacementTypeComponent
                                    value={form.fields.deviceType.value}
                                    onChange={{ events: { ...events.fields.deviceType } }}
                                    field={form.fields.deviceType}
                                    isDisabled={deviceType}
                                    onCheckBoxAction={this.handleCheckBoxAction}
                                    deviceMapping={deviceMapping}
                                />
                            </div>
                        </div>
                    </div>

                    <div className={cn("targeting-block", isCpmOrVcpmModel ? "" : "disabled-targeting")}>
                        <div className="targeting-item full-block">
                            <div className="title-wrapper">
                                <p>Time</p>
                                <span className="title-line" />
                            </div>
                            <div className="paragraph tour-campaign-schedule">
                                <FakeComponent
                                    value={form.fields.timetable.value}
                                    events={events}
                                    field={form.fields.timetable}
                                    onChangeUpdateCheckTimetableFlag={status =>
                                        onChangeUpdateCheckTimetableFlag(status)
                                    }
                                    updateCheckTimetableFlag={updateCheckTimetableFlag}
                                    onOpenTimetableWarning={onOpenTimetableWarning}
                                    isCpmOrVcpmModel={isCpmOrVcpmModel}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="targeting-block">
                        <div className="targeting-item full-block targeting-restrigtions">
                            <div className="title-wrapper">
                                <p>Restrictions</p>
                                <span className="title-line" />
                            </div>
                            <div className="paragraph tour-campaign-placement">
                                <RestrictionsComponent
                                    value={form.fields.restrictions.value}
                                    onChange={{ events: { ...events.fields.restrictions } }}
                                    field={form.fields.restrictions}
                                    restrictionsMapping={restrictionsMapping}
                                />
                            </div>
                        </div>
                    </div>
                </AccordionCardComponent>
            </form>
        );
    }
}

export interface CampaignMediaPlanFormProps {
    countryList: Country[];
}

export const CampaignMediaPlanForm = connect(
    (state: AppState, ownProps: CampaignMediaPlanFormProps): Partial<CampaignMediaPlanFormComponentProps> => {
        let zipList: string[];
        let placeList: string[];
        let placeAndZipList: Place[];
        let cleanZipList: string[] = [];
        let cleanPlaceList: string[] = [];

        if (state.campaignState.placeAndZipList.fetchState === FETCH_STATE_SUCCESS) {
            placeAndZipList = state.campaignState.placeAndZipList.data;
            zipList = placeAndZipList.map(el => el.zip);
            placeList = placeAndZipList.map(el => el.place);

            zipList.forEach(zip => {
                if (cleanZipList.length === 0 || !cleanZipList.some(cleanZip => cleanZip === zip)) {
                    cleanZipList.push(zip);
                }
            });

            placeList.forEach(place => {
                if (cleanPlaceList.length === 0 || !cleanPlaceList.some(cleanPlace => cleanPlace === place)) {
                    cleanPlaceList.push(place);
                }
            });
        }

        const adFormats: AdUnitFormat[] = getMappingData(state, "adunits");
        const languagesMapping: LanguagesMapping[] = getMappingData(state, "languages");
        const kpiMapping: KPIMapping[] = getMappingData(state, "kpi");
        const genderMapping: GenderMapping[] = getMappingData(state, "gender");
        const ageMapping: AgeMapping[] = getMappingData(state, "age");
        const interestsMapping: InterestMapping[] = getMappingData(state, "interests");
        const deviceMapping: DeviceMapping[] = getMappingData(state, "devices");
        const restrictionsMapping: RestrictionMapping[] = getMappingData(state, "restrictions");

        return {
            formData: campaignMediaPlanForm.selector(state.campaignState.campaignMediaPlanForm),
            adFormats,
            languagesMapping,
            genderMapping,
            ageMapping,
            kpiMapping,
            interestsMapping,
            deviceMapping,
            restrictionsMapping,
            countryList: ownProps.countryList,
            zipList: cleanZipList || [],
            placeList: cleanPlaceList || [],
            placeAndZipList: placeAndZipList || [],
            placeAndZipFetchState: state.campaignState.placeAndZipList.fetchState,
            updateCheckTimetableFlag: state.campaignState.updateCheckTimetableFlag
        };
    },
    (dispatch: Dispatch): Partial<CampaignMediaPlanFormComponentProps> => ({
        formEvents: campaignMediaPlanFormBindings.bind(dispatch, undefined),
        creativesFormEvents: campaignCreativesFormBindings.bind(dispatch, undefined),
        onClear: (fieldName: string, checkBoxState: boolean, isRadio?: boolean, mapping?: string[]) => {
            if (fieldName === "gender" || fieldName === "age" || fieldName === "deviceType") {
                dispatch(campaignMediaPlanForm.actions.fieldEdit(fieldName as any, checkBoxState ? [] : mapping));

                return;
            }
            dispatch(campaignMediaPlanForm.actions.fieldEdit(fieldName as any, isRadio ? "" : []));
        },
        onSetPriceModel: (priceModel: string) => {
            dispatch(setPriceModelAction({ priceModel }));
        },
        onSetPrimaryKPI: (primaryKPI: string) => {
            dispatch(setPrimaryKPIAction({ primaryKPI }));
        },
        onSetAdUnitFormat: (adUnitFormat: string) => {
            dispatch(setAdUnitFormatAction({ adUnitFormat }));
        },
        onInputSearch: (query, region) => {
            dispatch(searchLocationByQueryAction({ query, region }));
        },
        onChangeUpdateCheckTimetableFlag: (status: boolean) => {
            dispatch(changeUpdateCheckTimetableFlagAction({ status: status }));
        },
        onOpenTimetableWarning: () => {
            dispatch(openTimetableWarningAction());
        },
        matchStrict: (key, value, data): boolean => {
            return data.filter((item: any, index: number) => {
                return item[key] === value;
            }).length
                ? true
                : false;
        },
        debouncer: debouncer(800)
    })
)(CampaignMediaPlanFormComponent);

function debouncer(delay: number) {
    let timer: any = null;
    return (func: () => void) => {
        if (timer) clearTimeout(timer);
        timer = setTimeout(func, delay);
    };
}

function getMappingData(state: AppState, mappingName: string) {
    return FetchingState.isSuccess(state.mappings[mappingName]) ? state.mappings[mappingName].data : [];
}
